import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { LinkedEntityList } from 'app/agriculture/components/LinkedEntityList/LinkedEntityList';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { useContext } from 'react';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { LinkIcon } from 'app/agriculture/icons';
import { TankIndicator } from 'app/agriculture/routes/Tanks/TankIndicator/TankIndicator';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { validateLevelSnapshot } from 'app/agriculture/routes/Devices/utils/validateLevelSnapshot';
import { SkeletonLineChart } from 'app/agriculture/charts/SkeletonLineChart/SkeletonLineChart';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { TankLevelChart } from 'app/agriculture/routes/Tanks/TankDetails/components/TankLevelChart/TankLevelChart';
import { brandConfig } from 'app/agriculture/queries/snapshots/config/brandConfig';

export function LevelMonitorContent() {
    const { device } = useContext(DeviceDetailContext);

    const levelSnapshot = useSnapshot({
        parentId: device.id,
        snapshotType: brandConfig[device.brand].levelSnapshotType,
        shelfLife: brandConfig[device.brand].snapshotShelfLife,
    });

    const validatedLevelSnapshot = validateLevelSnapshot(levelSnapshot, { device });

    return (
        <>
            <ContentBox.Section>
                <SimpleGrid columns={3}>
                    <TankIndicator level={validatedLevelSnapshot?.percentageRemaining ?? null} />
                    <StatDisplay
                        name="Remaining"
                        value={
                            validatedLevelSnapshot?.volumeRemaining == null
                                ? null
                                : (validatedLevelSnapshot.volumeRemaining * 1000).toFixed(1)
                        }
                        unit="L"
                    />
                    <StatDisplay
                        name="Linked Tank"
                        emptyStateMessage="N/A"
                        value={
                            device.infrastructureId == null ? null : (
                                <LinkedEntityList
                                    entityIds={[device.infrastructureId]}
                                    icon={<LinkIcon />}
                                />
                            )
                        }
                    />
                    <StatDisplay
                        name="Fillable Volume"
                        value={device.tankMaxVolume == null ? null : device.tankMaxVolume * 1000}
                        unit="L"
                    />
                    <StatDisplay name="Fillable Height" value={device.tankMaxHeight} unit="m" />
                    {device.brand === 'Yarn' ? (
                        <StatDisplay
                            name="Calibration Distance"
                            value={device.tankCalibrationOffset}
                            unit="m"
                        />
                    ) : null}
                </SimpleGrid>
            </ContentBox.Section>
            {device.infrastructureId == null ? null : (
                <ContentBox.Section>
                    <SuspenseWrapper loadingComponent={<SkeletonLineChart title={'Avg Level'} />}>
                        <TankLevelChart deviceId={device.id} />
                    </SuspenseWrapper>
                </ContentBox.Section>
            )}
        </>
    );
}
